module.exports = __webpack_public_path__ + "prod/1.42.2/img/package-title.0494c35f.png";